export default "__VITE_ASSET__DwsiRZq8__"